/**
 * Link component integrated with React Router Dom
 */

import * as Headless from '@headlessui/react'
import React, { forwardRef } from 'react'
import { Link as RouterLink } from 'react-router-dom'

export const Link = forwardRef(function Link(
  props: { href: string } & Omit<React.ComponentPropsWithoutRef<typeof RouterLink>, 'to'>,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  // Prevent XSS by blocking dangerous URL protocols
  // Use trim() to prevent whitespace bypass attacks
  const hrefTrimmed = props.href.trim().toLowerCase()
  const isDangerousProtocol = 
    hrefTrimmed.startsWith('javascript:') ||
    hrefTrimmed.startsWith('data:') ||
    hrefTrimmed.startsWith('vbscript:')
  
  if (isDangerousProtocol) {
    // Block potentially malicious URLs
    return null
  }

  // External links (starting with http/https or //) should use regular anchor
  const isExternal = props.href.startsWith('http') || props.href.startsWith('//')
  
  if (isExternal) {
    return (
      <Headless.DataInteractive>
        <a {...props} ref={ref} target="_blank" rel="noopener noreferrer" />
      </Headless.DataInteractive>
    )
  }

  return (
    <Headless.DataInteractive>
      <RouterLink {...props} to={props.href} ref={ref} />
    </Headless.DataInteractive>
  )
})
